import Navbar from "../components/Navbar";
import Hero from "../sections/Hero";
import About from "../sections/About";
import Products from "../sections/Products";
import Services from "../sections/Services";
import WhyUs from "../sections/WhyUs";
import Process from "../sections/Process";
import ContactCTA from "../sections/ContactCTA";
import Footer from "../components/Footer";
import Clientele  from "../sections/Clientele";
import Certifications from "../sections/Certifications";
import AnnouncementPopup from "../components/AnnouncementPopup";


export default function Home() {
  return (
    <>
      <Navbar />
      <Hero />
      <Clientele />
      <About />
      <Products />
      <Services />
      <WhyUs />
      <Process />
      <ContactCTA />
      <Certifications />
      <Footer />
      <AnnouncementPopup />
    </>
  );
}